/** =========================================================
 * Projectors controller
 =========================================================*/

(function () {
  'use strict';

  angular
    .module('app.page-projectors')
    .controller('ProjectorsController', ProjectorsController);

  ProjectorsController.$inject = ['$rootScope', '$scope', '$api', '$state', '$stateParams', '$translate'];

  function ProjectorsController($rootScope, $scope, $api, $state, $stateParams, $translate) {
    var vm = this;

    vm.pageTitle = $state.current.title;
    vm.pageSubTitle = $state.current.subTitle;
    vm.init = false;

    if ($rootScope.appConfig) {
      activate();
    } else {
      var getAppConfig = $rootScope.$watch('appConfig', function (value) {
        if (value) {
          activate();
          getAppConfig();
        }
      });
    }

    // //////////////

    function activate() {
      vm.init = true;

      Raven.captureBreadcrumb({
        message: 'Page projectors',
        data: {
          filters: $stateParams.filters
        }
      });

      vm.tableConfig = {
        model: 'projector',
        getDataParams: {
          order: {
            id: 'desc'
          },
          with: [{
            projector_employees: ['id', 'name']
          }],
          count: ['projects']
        },
        filters: angular.copy($stateParams.filters),
        resources: ['projector_employee'],
        fields: [{
          title: 'Name',
          key: 'name',
          order: true
        }, {
          title: 'Phone',
          key: 'phone',
          order: true
        }, {
          title: 'Email',
          key: 'email',
          order: true
        }],
        add: {
          template: 'app/views/dialogs/item-projector.html',
          wide: true
        },
        edit: {
          template: 'app/views/dialogs/item-projector.html',
          wide: true,
          except: ['projects_count']
        },
        delete: {},
        linkButtons: [{
          title: 'Designers',
          icon: 'icon-people',
          class: 'btn-info mr-1',
          permission: $rootScope.helpers.hasPermissionTo('projector_employee view'),
          action: function (item) {
            try {
              $state.go('app.page-projector-employees', {
                filters: [{
                  name: $translate.instant('Projector') + ': ' + item.name,
                  attr: 'whereHas',
                  value: [
                    ['projectors', 'projector_id', '=', item.id]
                  ]
                }]
              });
            } catch (error) {
              Raven.captureException(error);
            }
          },
          text: function (item) {
            try {
              return item.projector_employees.length;
            } catch (error) {
              Raven.captureException(error);
            }

            return '';
          }
        }, {
          title: 'Projects',
          icon: 'icon-folder-alt',
          class: 'btn-info mr-1',
          permission: $rootScope.helpers.hasPermissionTo('project view'),
          action: function (item) {
            try {
              $state.go('app.page-projects', {
                filters: [{
                  name: $translate.instant('Projector') + ': ' + item.name,
                  attr: 'where',
                  value: [
                    ['projector_id', '=', item.id]
                  ]
                }]
              });
            } catch (error) {
              Raven.captureException(error);
            }
          },
          text: function (item) {
            try {
              return item.projects_count;
            } catch (error) {
              Raven.captureException(error);
            }

            return '';
          }
        }]
      };

      vm.tableConfig.getData = function () {
        try {
          return $rootScope.helpers.defaultGetData(vm.tableConfig);
        } catch (error) {
          Raven.captureException(error);
        }

        return $rootScope.helpers.emptyPromise();
      };

      vm.tableConfig.getData();

      $rootScope.helpers.initActiveTableConfig(vm.tableConfig);
    }
  }
})();
